import {
  FulfillmentGroupTagSource,
  TagKind,
} from "@redotech/redo-common-model/tag";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { PillTheme } from "@redotech/redo-web/pill";

export function getMarketplaceOrderTags(row: FulfillmentGroupData) {
  return Array.from(new Set(row.orders.flatMap((order) => order.tags))).map(
    (tag) => ({
      name: tag,
      pillTheme: PillTheme.NORMAL,
      source: FulfillmentGroupTagSource.MERCHANT,
      kind: TagKind.FULFILLMENT_GROUP,
    }),
  );
}
